import React from "react";
import "./testimonials.css";
import {Data} from "./Data";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination"; 
import { Pagination } from "swiper/modules";

const Testimonials = () => {
  return (
    <section className="testimonials container section" id="testimonials">
      <h2 className="section__title">Testimonials</h2>
      <span className="section__subtitle">My clients says</span>

      <Swiper className="testimonials__container"
        // slidesPerView={1}
        // spaceBetween={10}
        loop={true}
        grabCursor={true}
        spaceBetween={24}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          576: {
            slidesPerView: 2,
            // spaceBetween: 20,
          },
          768: {
            // slidesPerView: 4,
            slidesPerView: 2,
            // spaceBetween: 40,
            spaceBetween: 48,
          },
        //   1024: {
        //     slidesPerView: 5,
        //     spaceBetween: 50,
        //   },
        }}
        modules={[Pagination]}>
        {Data.map(({id, image, title, description}) => {
            return (
                <SwiperSlide className="testimonials__card" key={id}>
                    <img src={image} alt=""
                    className="testimonials__img"/>

                    <h3 className="testimonials__name">{title}</h3>
                    <p className="testimonials__description">{description}</p>
                </SwiperSlide>
            );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
